



import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

export const environment = {
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  production: true,
  firebase: {
    apiKey: "AIzaSyDzGEcaUaQPUxwVbMogQOa5Mj6V_MNHybs",
    authDomain: "hopeeventsapp-2c461.firebaseapp.com",
    projectId: "hopeeventsapp-2c461",
    storageBucket: "hopeeventsapp-2c461.appspot.com",
    messagingSenderId: "977119506208",
    appId: "1:977119506208:web:ecd9bd878fba71f260f145",
    measurementId: "G-3SRYTVWXDV"
  }
};

export const app = initializeApp(environment.firebase);
export const auth = getAuth(app);